import React from 'react';
import { useReveal } from '../lib/useReveal';
const BONOS = [{
  num: '01',
  title: 'Kit de Primera Sesión',
  desc: 'Tu pack profesional imprimible para la primera sesión. Formularios, guión de apertura y cierre, checklists y modelo de registro profesional completo. Atendé con seguridad desde el minuto 1.',
  value: '$8.000'
}, {
  num: '02',
  title: 'Diccionario Express de Preguntas Poderosas',
  desc: '120 preguntas organizadas por tipo de conflicto. Nunca más te quedás sin saber qué preguntarle a un cliente en medio de una sesión.',
  value: '$10.000'
}, {
  num: '03',
  title: 'Árbol Bio en 15 Min',
  desc: '5 plantillas de árbol genealógico bio listas para imprimir. Con guía de uso, leyenda de símbolos y checklist de patrón confirmado.',
  value: '$9.000'
}, {
  num: '04',
  title: 'Guía de Objeciones y Respuestas',
  desc: 'Las 15 dudas más frecuentes de tus clientes con respuestas listas para WhatsApp y sesión. Sin discutir. Sin prometer lo que no podés cumplir.',
  value: '$8.000'
}, {
  num: '05',
  title: 'Checklist de Diagnóstico del Terapeuta',
  desc: 'Autoevaluación en 7 habilidades clave más plan de mejora de 14 días con acciones de 10 minutos por día.',
  value: '$9.000'
}, {
  num: '06',
  title: 'Sesión Online Pro',
  desc: 'Setup técnico, plantillas de mensajes, sistema de cobro y protocolos completos para atender online como profesional desde Argentina para el mundo.',
  value: '$9.000'
}];
export function BenefitsSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-18">
      <div className="container mx-auto max-w-4xl" data-id="element-19">
        <div ref={ref1} className={`reveal text-center mb-12 ${vis1 ? 'is-visible' : ''}`} data-id="element-20">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 leading-tight text-[#eab308] uppercase tracking-widest" data-id="element-21">
            🎁 6 BONOS INCLUIDOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-22">
          {BONOS.map((bono, i) => {
          const [ref, vis] = useReveal();
          return <div key={i} ref={ref} className={`reveal relative bg-[#111111] border border-white/10 rounded-xl p-6 pt-8 transition-all hover:border-[#eab308]/30 ${vis ? 'is-visible' : ''}`} style={{
            transitionDelay: `${i * 50}ms`
          }} data-id="element-23">
                <div className="absolute -top-3 left-6 bg-[#eab308] text-black font-bold text-xs px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-24">
                  🎁 BONO {bono.num}
                </div>

                <h3 className="text-white font-serif font-bold text-xl mb-3 leading-tight" data-id="element-25">
                  {bono.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-4 flex-grow" data-id="element-26">
                  {bono.desc}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-white/5 mt-auto" data-id="element-27">
                  <span className="text-gray-500 line-through text-sm" data-id="element-28">
                    {bono.value}
                  </span>
                  <span className="text-[#eab308] font-bold text-sm tracking-wider" data-id="element-29">
                    GRATIS
                  </span>
                </div>
              </div>;
        })}
        </div>

        <div ref={ref2} className={`reveal text-center bg-gradient-to-r from-transparent via-[#eab308]/10 to-transparent py-4 ${vis2 ? 'is-visible' : ''}`} data-id="element-30">
          <p className="text-xl md:text-2xl font-serif font-bold text-white" data-id="element-31">
            Valor total bonos:{' '}
            <span className="text-gray-500 line-through" data-id="element-32">$53.000</span>{' '}
            <span className="text-[#eab308]" data-id="element-33">→ GRATIS con tu MegaPack</span>
          </p>
        </div>
      </div>
    </section>;
}